import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { CommercialInvoicePrintComponent } from '../commercial-invoice-print/commercial-invoice-print.component';

@Component({
  selector: 'app-commercial-invoice',
  templateUrl: './commercial-invoice.component.html',
  styleUrls: ['./commercial-invoice.component.css']
})
export class CommercialInvoiceComponent implements OnInit {

  model = {
    'table_name': 'invoice', 'customer_name': '', 'customer_no': '',
    'branch_id': '0', 'store_id': '0', 'title': ''
  };

  branchList = [];
  allStoreList = [];
  storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];

  private dp = [];
  displayedColumns = ['choose', 'invoice_no', 'invoice_date', 'customer_name', 'mobile', 'final_total',
    'payment_method', 'created_by', 'branch_name', 'inv_status'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  printDialogRef: MatDialogRef<CommercialInvoicePrintComponent>;

  Success_Msg; Error_Msg; Customer_Placeholder; Customer_Err_Msg;
  Select_Inv_Msg;

  search_obj = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile']
      // 'condition': " AND `branch_id` = '" + this.model['branch_id'] + "'"
    }]
  };


  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Customer_Err_Msg').subscribe((res: string) => {
      this.Customer_Err_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Customer_Placeholder;

    translate.get('Select_Inv_Msg').subscribe((res: string) => {
      this.Select_Inv_Msg = res;
    });

  }

  ngOnInit() {

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  onChangeSearch = function (search_result: object) {
    console.log(search_result['no']);
    this.model['customer_no'] = search_result['no'];
  }

  search() {

    if (this.model['customer_no'] == '') {
      alert(this.Customer_Err_Msg);
      return;
    }

    let obj = { cmd: 'getSaleInvoiceList' };

    obj['customer_no'] = this.model['customer_no'];

    if (this.model['branch_id'] == '0')
      obj['store_list'] = this.allStoreList;
    else {
      if (this.model['store_id'] != '0')
        obj['store_id'] = this.model['store_id'];
      else {
        let allStoreList = [];
        this.storeList.forEach(element => {
          if (element.store_id != '0')
            allStoreList.push({ 'store_id': element.store_id });
        });
        obj['store_list'] = allStoreList;
      }
    }

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  choose_all() {
    let choose_all = document.getElementById('choose_all') as HTMLInputElement;
    if (choose_all.checked) {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.invoice_no) as HTMLInputElement;
        choose.checked = true;
      });
    }
    else {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.invoice_no) as HTMLInputElement;
        choose.checked = false;
      });
    }
  }

  print() {
    let dialog_data = [];
    this.dp.forEach(element => {
      let choose = document.getElementById('choose_' + element.invoice_no) as HTMLInputElement;
      if (choose.checked)
        dialog_data.push(element);
    });

    if (dialog_data.length == 0) {
      alert(this.Select_Inv_Msg);
      return;
    }
    this.printDialogRef = this.dialog.open(CommercialInvoicePrintComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.printDialogRef
      .afterClosed()
      .subscribe(result => {
      });
  }

}
